<template>
  <t-breadcrumb :max-item-width="'150'" class="tdesign-breadcrumb">
    <t-breadcrumbItem v-for="item in crumbs" :key="item.to" :to="item.to">
      {{ item.title }}
    </t-breadcrumbItem>
  </t-breadcrumb>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

import { RouteMeta } from '@/types/common/ui';

const { locale } = useI18n();
const router = useRouter();
const route = useRoute();

// 根据 operationType 参数处理标题
const processTitle = (title: string | undefined): string | undefined => {
  if (!title) return title;

  const operationType = route.query.operationType as string;

  if (operationType === 'edit') {
    return title.replace('新增', '编辑');
  }
  if (operationType === 'changeOrder') {
    return title.replace('新增订单', '改单');
  }

  return title;
};

const crumbs = computed(() => {
  const breadcrumbs: any[] = [];
  const { matched } = route;

  for (let i = 0; i < matched.length; i++) {
    const record = matched[i];
    const meta = record.meta as RouteMeta;

    if (meta?.hiddenBreadcrumb) continue;

    // 获取标题
    let title = typeof meta?.title === 'string' ? meta.title : meta?.title?.[locale.value];

    // 处理标题
    title = processTitle(title);

    // 构建当前层级的完整路径
    const basePath = matched
      .slice(0, i + 1)
      .map((m) => m.path)
      .join('');
    const fullPath = basePath.startsWith('/') ? basePath : `/${basePath}`;

    // 如果是最后一级路由，检查是否需要插入中间层级
    if (i === matched.length - 1 && meta?.parentRouteName) {
      // 根据meta中定义的父路由名称查找
      const parentRoute = router.getRoutes().find((r) => r.name === meta.parentRouteName);
      if (parentRoute && !breadcrumbs.find((b) => b.path === parentRoute.path)) {
        const parentMeta = parentRoute.meta as RouteMeta;
        let parentTitle = typeof parentMeta?.title === 'string' ? parentMeta.title : parentMeta?.title?.[locale.value];

        // 处理父级标题
        parentTitle = processTitle(parentTitle);

        breadcrumbs.push({
          path: parentRoute.path,
          to: `${matched[i - 1].path}/${parentRoute.path.split('/').pop()}`,
          title: parentTitle,
        });
      }
    }

    // 添加当前层级
    breadcrumbs.push({
      path: record.path,
      to: fullPath,
      title,
    });
  }
  return breadcrumbs;
});
</script>

<style scoped>
.tdesign-breadcrumb {
  margin-bottom: 24px;
}
</style>
